import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { IdType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'IDType',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl, t } = useI18nTl('Operation')



const statusLabel = computed(() => {
  switch (props.type) {
    case IdType.IT_LOCAL_PLUG: // 本地即插即充启动
      return tl('localPlug')
    case IdType.IT_LOCAL_ADMIN: // 本地管理员启动
      return tl('localAdmin')
    case IdType.IT_LOCAL_IDENTITY_CARD: // 鉴权卡刷卡本地鉴权启动
      return tl('localIdentityCard')
    case IdType.IT_ONLINE_IDENTITY_CARD: // 鉴权卡刷卡在线鉴权启动
      return tl('onlineIdentityCard')
    case IdType.IT_LOCAL_WALLET_CARD: // 本地钱包卡刷卡启动
      return tl('localWalletCard')
    case IdType.IT_LOCAL_VIN: // 车辆VIN本地鉴权启动
      return tl('localVin')
    case IdType.IT_ONLINE_VIN: // 车辆VIN在线鉴权启动
      return tl('onlineVin')
    case IdType.IT_BLUETOOTH: // 本地通过蓝牙启动
      return tl('bluetooth')
    case IdType.IT_MAC: // 本地通过输入校验码启动
      return tl('mac')
    case IdType.IT_REMOTE_ADMIN: // 远程管理员启动
      return tl('remoteAdmin')
    case IdType.IT_REMOTE_USER: // 远程用户启动
      return tl('remoteUser')
    case IdType.IT_REMOTE_API: // 远程用户启动
      return tl('remoteAPI')
    case IdType.IT_CHARGING_PLANS: // 充电计划启动
      return tl('chargingPlans')
    case IdType.IT_NO_SENSE: // 无感启动
      return tl('noSense')
  }
  return t('Base.unknown')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})